'use strict';

export const VIEW_LATEST_ESTIMATE_QUERY = 'viewLatestEstimate';
export const BUILD_A_STUDY_PATH = '/home/build-a-study';

export const LATEST_ESTIMATE_NOT_FOUND_MESSAGE =
	'We could not find a saved estimate for your account. Complete the study builder to request a new estimate.';

/** Shown when a stored estimate exists but its saved study options can no longer drive the wizard. */
export const LATEST_ESTIMATE_UNAVAILABLE_MESSAGE =
	'We could not reopen your saved estimate because the study options it used are no longer available. '
	+ 'Complete the study builder to request a new estimate.';

/**
 * @param {string|null|undefined} search location.search (with or without leading ?)
 * @returns {boolean}
 */
export function isViewLatestEstimateQuery(search) {
	const raw = String(search || '');
	const params = new URLSearchParams(raw.startsWith('?') ? raw.slice(1) : raw);
	return String(params.get(VIEW_LATEST_ESTIMATE_QUERY) || '').toLowerCase() === 'true';
}

/**
 * Canonical return URL for login after clicking the email deep link.
 * @param {string|null|undefined} origin
 * @returns {string}
 */
export function buildViewLatestEstimateReturnUrl(origin) {
	const base = String(origin || '').trim().replace(/\/$/, '') || '';
	return `${base}${BUILD_A_STUDY_PATH}?${VIEW_LATEST_ESTIMATE_QUERY}=true`;
}

/**
 * @param {string|null|undefined} search
 * @returns {string} pathname+search without the viewLatestEstimate param (search may be '')
 */
export function buildPathWithoutViewLatestEstimate(pathname = BUILD_A_STUDY_PATH, search = '') {
	const raw = String(search || '');
	const params = new URLSearchParams(raw.startsWith('?') ? raw.slice(1) : raw);
	params.delete(VIEW_LATEST_ESTIMATE_QUERY);
	const next = params.toString();
	return next ? `${pathname}?${next}` : pathname;
}
